import { ProductEntity } from './product.entity';

export interface CallToActionResult {
	naam: string;
	doelVanDeActie: CallToActionResultEnum;
	annotaties: string[];
	actieLink: string;
}

export enum CallToActionResultEnum {
	AanvraagStarten = 'AanvraagStarten',
	ToegangVragen = 'ToegangVragen',
	MeerInfoBekijken = 'MeerInfoBekijken',
	Aanmelden = 'Aanmelden',
	DuoZelfRealisatie = 'DuoZelfRealisatie',
	DuoBezwaar = 'DuoBezwaar',
	ToegangVragenEloket = 'ToegangVragenEloket'
}

/**
 * The frontend-friendly enum that is used to differentiate between the different
 * actions an `Offers` button can have.
 */
export enum CallToActionEnum {
	StartCase = 'START_CASE',
	RequestAccess = 'REQUEST_ACCESS',
	MoreInfo = 'MORE_INFO',
	Login = 'LOGIN',
	DuoSelfRealisation = 'DUO_SELF_REALISATION',
	DuoObjection = 'DUO_OBJECTION',
	RequestAccessEloket = 'REQUEST_ACCESS_ELOKET'
}

/**
 * These values are used to track which button on the Offers page was clicked,
 * as well as the spotlight product.
 *
 * These keys should equal the values of {@link CallToActionEnum}
 */
export enum CallToActionGTATypeEnum {
	MORE_INFO = 'btn_click_meer_informatie',
	REQUEST_ACCESS = 'btn_click_toegang_vragen',
	START_CASE = 'btn_click_aanvraag_starten'
}

/**
 *
 */
export enum CallToActionOriginEnum {
	Offers = 'Zoek in het aanbod',
	Spotlight = 'Dashboard'
}

export interface CallToActionEntity {
	name: string;
	action: CallToActionEnum;
	link: string;
	annotations: string[];
}

/**
 * The type of the event that is emitted when a call to action is clicked.
 */
export interface CallToActionClickedEvent {
	action: CallToActionEntity;
	product: ProductEntity;
}
